import modalService from '@/utils/services/ModalService'
import { IDashboardFilter } from '@/dashboard/models/DashboardBaseFilterModel'

export default {
    methods: {
        clearFilter(filter:IDashboardFilter):void {
            filter.updatesToInitialState()
        },
        async showFilterModal(id:string):Promise<any> {
            return modalService.show(id)
        },
        async closeFilterModal(id:string):Promise<any> {
            return modalService.hide(id)
        },
    },
}
